/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { ResultInformation } from '../../models/result-information';
import { Inject, Injectable } from '@angular/core';
import {
  ADD_FITTING_TAB_FACADE_TOKEN,
  IAddFittingTabFacade,
} from '../../../../../data-access/src/lib/domain/facades-models/add-fitting-tab-facade-interface';
import { IResultContainerFacade } from '../../../../../data-access/src/lib/domain/facades-models/result-container-facade-interface';
import { selectCurateSearchResult, selectLastCurateSearchQuery } from '../curate-search/curate-search-selector';
import { CurateSearchVm } from '../../models/curate-search-vm';
import { searchForCurateSearchAction, showAddFittingResultPanelAction } from '../curate-search/curate-search-actions';
import { selectTreeViewResultInformation } from '../fitting-tree-view/fitting-tree-view-selector';
import { LocalStorageService } from '../../../../../utils/src/lib/local-storage/local-storage.service';
import { SysqueElectricalState } from '../../models/sysque-electrical-state';
import { SystemStateManager } from '../../../../../utils/src/lib/system-state-manager.service';
import { DotNetRequestMessageService } from '@mep/web-browser-bridge';
import { ResultItemInformation } from '../../models/result-item-information';
import { AddToSystemReturnCodes } from '../../models/add-to-system-return-codes';

@Injectable({ providedIn: 'root' })
export class ResultContainerFacade implements IResultContainerFacade {
  result$: Observable<ResultInformation[]>;
  notifySelectorChange$: BehaviorSubject<string> = new BehaviorSubject<string>('curateSearch');

  constructor(
    private store: Store,
    @Inject(ADD_FITTING_TAB_FACADE_TOKEN) private addFittingTabFacade: IAddFittingTabFacade,
    private localStorageService: LocalStorageService,
    private stateManager: SystemStateManager,
    private messageHandler: DotNetRequestMessageService,
  ) {
    this.addFittingTabFacade.notifySelectorChange.subscribe((data) => {
      if (data.toLowerCase() === 'treeview') {
        this.result$ = this.selectTreeVewResult();
      }
      if (data.toLowerCase() === 'curatesearch') {
        this.result$ = this.selectCurateSearchResult();
      }
      this.notifySelectorChange$.next(data);
    });
  }

  selectTreeVewResult(): Observable<ResultInformation[]> {
    return this.store.select(selectTreeViewResultInformation);
  }

  selectLastCurateSearchQuery(): Observable<CurateSearchVm> {
    return this.store.select(selectLastCurateSearchQuery);
  }

  selectCurateSearchResult(): Observable<ResultInformation[]> {
    return this.store.select(selectCurateSearchResult);
  }

  getLocalStorageUpdate(): Observable<string> {
    return this.localStorageService.localStorageUpdate$;
  }

  getLocalStorageItem(key: string): any {
    return this.localStorageService.getStorage(key);
  }

  getAddFittingState(): SysqueElectricalState {
    return this.stateManager.getAddFittingModeState();
  }

  updateLocalStorage(key: string, value: any) {
    this.localStorageService.updateDispatchLocalStorage(key, value);
  }

  addToSystem(
    itemInfo: ResultItemInformation,
    selectedSystem: string,
    selectedCategory: string,
    isCustomContent: string
  ): void {
    console.log('Request to backend to check if we can add the item and open the specific family information dialog');
    from<Promise<AddToSystemReturnCodes>>(
      this.messageHandler.sendRequestAsync('AddToSystem', [itemInfo, selectedSystem, selectedCategory, isCustomContent])
    );
  }
}
